/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('screens/skilldrill/skilldrill',['require','underscore','jquery','backbone','core/base-screen','modules/paging/page'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var BaseScreen = require('core/base-screen');
  var Page = require('modules/paging/page');

  var PageCollection = Backbone.Collection.extend({
    model: Page
  });

  /*****************************************************************************************************************///}

  var SkillDrill = BaseScreen.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    ui: {
      close: '.close'
    },
    events: {
      'click .node': 'nodePressed',
      'click @ui.close': 'closePressed'
    },
    regions: {
      pageHolder: '.page-container'
    },

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      BaseScreen.prototype.initialize.apply(this, arguments);

      //console.log('SkillDrill::initialize');

      var pages = _.map(this.model.get('nodes'), function(node)
      {
        var page = node['page'];
        page.autonomous = true;
        return node['page'];
      });

      this.nodes = new PageCollection(pages);
    },

    onShow: function()
    {
      this.playMedia();
    },

    nodePressed: function(e)
    {
      var index = $(e.currentTarget).index();
      var page = this.nodes.at(index);

      this.$el.find(this.ui.close).toggle(page.get('complete'));

      // listen for ready event
      this.listenToOnce(page, 'page.ready', function(e)
      {
        var view = page.create();

        this.$el.find('.page-container').show();

        this.pageHolder.show(view);

        this.trigger('page.loaded', page);
      });

      // listen for ready event
      this.listenTo(page, 'complete', function(e)
      {
        this.$el.find('.node').eq(index).addClass('complete');
        this.$el.find(this.ui.close).show();
      });

      // load the page
      page.load();
    },

    closePressed: function(e)
    {
      this.pageHolder.empty();
      this.$el.find('.page-container').hide();
      this.$el.find(this.ui.close).hide();

      var allComplete = this.nodes.every('complete');

      if (allComplete)
        this.finish();
    }

  /*****************************************************************************************************************///}

  });

  return SkillDrill;

});

